import { connect } from 'react-redux';
import { useEffect } from 'react';
// import { ListTable } from '../../';
import {
	addCommas, classes, convertToHigherUnit
} from '@/Helpers';
import styles from './TransitAnalysisListPage.module.scss';
import analyticsAction from '../../Actions/analytics.actions';
import { useAuth } from '../../Components/Auth/Login/auth';
import { ListTable } from '../../Components/ListTable';
// import { ArrangePages } from '../../../Components/Arrange Pages';

const TABLE_COLUMNS = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Rate',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Transit Value',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Transit Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Loss Value',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Loss Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Transit Loss Percentage',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Product Name': 'productName',
	Category: 'productCategoryName',
	'Sub Category': 'productSubcategoryName',
	'UY Id': 'id',
	'SKU Code': 'clientVariantId',
	Unit: 'unit',
	Store: 'storeName',
	Rate: 'rate',
	'Total Transit Value': 'totalTransitValue',
	'Total Transit Qty': 'totalTransitQty',
	'Total Loss Value': 'totalLossValue',
	'Total Loss Qty': 'totalLossQty',
	'Transit Loss Percentage': 'transitLossPercentage',
};

const getRowStyles = (item) => {
	switch (item?.result) {
		default:
			return styles.normal;
	}
};

const TransitAnalysisListPage = (props) => {
	// const history = useHistory();
	const { data, setAnalyticsType, ANALYTICS_TYPE, exportTransitAnalytics } =
		props;
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs || {};

	useEffect(() => {
		setAnalyticsType(ANALYTICS_TYPE, {});
	}, []);

	const SPECIAL_ITEMS = {
		'Product Name': (_, obj) => {
			// eslint-disable-next-line prefer-template
			return obj?.productName + (obj?.variantName ? ' (' + obj?.variantName + ')' : '');
		},
		Unit: (unitValue) => {
			return convertToHigherUnit(unitValue)?.unit;
		},
		'Variance Cost': (value) => {
			return addCommas(value, measurement, true);
		},
		'Variance QTY': (_, obj) => {
			// eslint-disable-next-line max-len
			return convertToHigherUnit(obj?.unit, (obj.totalLossQty ?? 0))?.value?.toFixed(2);
		},
	};

	return (
		<div className={classes(styles.root, 'list-page-root')}>
			<ListTable
				fixedHeaderTop={0}
				hasDateRange
				// renderColumn={renderColumn}
				colMap={COLMAP}
				special={SPECIAL_ITEMS}
				data={data?.map((obj) => {
					const rowStyles = getRowStyles(obj);
					return {
						...obj,
						rowStyles,
						rowId: obj?.id,
						id: obj?.variantId,
					};
				})}
				columns={[...TABLE_COLUMNS]}
				actions={[]}
				onExportClick={exportTransitAnalytics}
			/>
		</div>
	);
};

const mapStateToProps = () => {
	return {};
};
const mapDispatchToProps = {
	setAnalyticsType: analyticsAction.setAnalyticsType,
	exportTransitAnalytics: analyticsAction.exportTransitAnalytics,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TransitAnalysisListPage);
